import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import CategoryLinkGroup from './CategoryLinkGroup'

const MenuGroupedCategories = ({groupedCategories, locale, categoryData, groupLinkGap, styles}) => (
    <Flex {...styles.groupListContainer}>
        {groupedCategories.map((cat, id) => (
            <CategoryLinkGroup
                key={cat?.uid + cat?.group_title + id}
                group={cat}
                categoryData={categoryData}
                locale={locale}
                styles={styles}
                {...styles.groupLinkContainer}
                {...(groupLinkGap != null ? {gap: groupLinkGap} : {})}
            />
        ))}
    </Flex>
)

MenuGroupedCategories.propTypes = {
    groupedCategories: PropTypes.arrayOf(
        PropTypes.shape({
            uid: PropTypes.string,
            group_title: PropTypes.string,
            redirect: PropTypes.array,
        }),
    ).isRequired,
    categoryData: PropTypes.object,
    groupLinkGap: PropTypes.string,
    locale: PropTypes.shape({
        alias: PropTypes.string,
    }),
    /** MenuTemplate multi-style config of the calling template */
    styles: PropTypes.object.isRequired,
}

export default MenuGroupedCategories
